import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { Alert, AlertColor, Snackbar } from '@mui/material';
import s from './styles.module.scss';

export interface IAppSnackbarRef {
  open: (message: string, severity?: AlertColor) => void;
}

const AppSnackbar = forwardRef<IAppSnackbarRef>((props, ref) => {
  const [message, setMessage] = useState<string>('');
  const [severity, setSeverity] = useState<AlertColor>('info');
  const [snackbarState, setSnackbarState] = useState<boolean>(false);

  const open = (message: string, severity?: AlertColor) => {
    setMessage(message);
    if (severity) setSeverity(severity);
    setSnackbarState(true);
  };

  useImperativeHandle(ref, () => ({ open }));

  return (
    <Snackbar
      onClose={() => setSnackbarState(false)}
      open={snackbarState}
      autoHideDuration={2000}
      anchorOrigin={{
        horizontal: 'right',
        vertical: 'bottom',
      }}
    >
      <Alert
        className={s['alert']}
        icon={false}
        severity={severity}
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
});

AppSnackbar.displayName = 'AppSnackbar';

export default AppSnackbar;
